interface AppConfiguration {
    backendUrl: string
    enabledTabs: {
        nluData: boolean
        nluDataLookup: boolean
        nluDataStats: boolean
        responses: boolean
        rules: boolean
        slotsForms: boolean
        actions: boolean
        configuration: boolean
        faq: boolean
        conversations: boolean
        messageTemplates: boolean
        messages: boolean
        analytics: boolean
        users: boolean
        importExport: boolean
        dataSources: boolean
    }
    adminEvalEnabled: boolean
    showConversationsCategoryFilterCategories: {
        entities: boolean
        intents: boolean
        actions: boolean
        other: boolean
    }
    defaultPage: string
}

const fallbackConfiguration: AppConfiguration = {
    backendUrl: '',
    enabledTabs: {
        nluData: false,
        nluDataLookup: false,
        nluDataStats: false,
        responses: false,
        rules: false,
        slotsForms: false,
        actions: false,
        configuration: false,
        faq: false,
        conversations: false,
        messages: false,
        messageTemplates: false,
        analytics: false,
        users: false,
        importExport: false,
        dataSources: false,
    },
    adminEvalEnabled: false,
    showConversationsCategoryFilterCategories: {
        entities: false,
        intents: false,
        actions: false,
        other: false,
    },
    defaultPage: '',
}

let configuration: AppConfiguration = fallbackConfiguration

export const loadAppConfiguration = async (): Promise<void> => {
    try {
        const res = await fetch('/config/config.json', { cache: 'no-store' })
        if (res.ok) {
            configuration = await res.json()
        }
    } catch {
        console.error('Failed to load app configuration, using fallback.')
    }
}

export const getConfiguration = (): AppConfiguration => configuration
